
<script>
import router from "../../router";
import Multiselect from "vue-multiselect";
import moment from "moment";
export default {
  name: "StockAdjustment",
  components: {
    Multiselect
  },
  data() {
    return {
      itemList: [],
      storeList: [],
      selected_items: [],
      filterObj: {
        store_id: ""
      },
      note_count: 0,
      order: {
        id: null,
        store_id: null,
        items: [],
        reason: "",
        note: null
      }
    };
  },
  methods: {
    getItemList() {
      if (this.filterObj.store_id) {
        this.order.store_id = this.filterObj.store_id;
      }
      this.itemList = [];
      this.$api
        .getAPI({ _action: "/item/purchase_order", _body: this.filterObj })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.itemList = res.list;
            this.selected_items = [];
          }
          this.$validator.reset();
          this.errors.clear();
        })
        .catch(e => {});
    },
    getStoreList() {
      this.$api
        .getAPI({ _action: `/store/list?cacheVersion=${localStorage.getItem('cacheVersion') || '0'}` })
        .then(res => {
          if (res.list != null && res.list.length > 0) {
            this.storeList = res.list;
          }
        })
        .catch(e => {});
    },

    removeSelectedItem(index) {
      if (this.order.reason == "RECEIVE_ITEMS") {
        this.selected_items[index].add_stock = "";
        this.selected_items[index].stock_after = "";
      }
      if (this.order.reason == "LOSS" || this.order.reason == "DAMAGE") {
        this.selected_items[index].remove_stock = "";
      }

      if (this.order.reason == "INVENTORY_COUNT") {
        this.selected_items[index].counted_stock = "";
      }
      this.selected_items.splice(index, 1);
    },
    validateForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save();
          return;
        }
      });
    },
    save() {
      this.order.items = this.selected_items;
      this.$api
        .postAPI({
          _action: "/stock_adjustment/",
          _body: this.order,
          _buttonId: "save-btn"
        })
        .then(res => {
          this.$notify({
            group: "foo",
            text: res.message,
            type: "success"
          });
          router.push("/stock-adjustment");
        })
        .catch(e => {
          console.log(e.message);
        });
    },
    details(id) {
      this.order = {};
      this.selected_items = [];

      this.$api
        .getAPI({
          _action: "/stock_adjustment/detail/" + id
        })
        .then(res => {
          this.order = res.transfer_order;

          if (this.order.note) {
            this.note_count = this.order.note.length;
          }

          setTimeout(() => {
            for (var i = 0; i < res.items.length; i++) {
              if (res.items[i].item) {
                this.selected_items.push(res.items[i].item);
              }
            }
          }, 500);

          this.filterObj.store_id = this.order.store_id;
        });
    },
    changeNoteCount() {
      if (this.note_count >= 300) {
        this.order.note = this.order.note.substring(0, 300);
        this.note_count = 300;
      }
      this.note_count = this.order.note.length;
    },
    calculateAmount(index) {
      if (!this.selected_items[index].in_stock) {
        this.selected_items[index].in_stock = 0;
      }
      if (!this.selected_items[index].add_stock) {
        this.selected_items[index].add_stock = 0;
      }

      this.selected_items[index].stock_after =
        1 * this.selected_items[index].add_stock +
        1 * this.selected_items[index].in_stock;
      this.$set(this.selected_items, index, this.selected_items[index]);
    },
    calculateStock(index) {
      if (
        this.selected_items[index].in_stock != null &&
        this.selected_items[index].in_stock > 0 &&
        this.selected_items[index].remove_stock != null &&
        this.selected_items[index].remove_stock > 0
      ) {
        this.selected_items[index].stock_after =
          1 * this.selected_items[index].in_stock -
          1 * this.selected_items[index].remove_stock;

        this.$set(this.selected_items, index, this.selected_items[index]);
      }
    }
  },
  mounted() {
    this.getStoreList();
    this.getItemList(false);
    if (this.$route.params.id) {
      this.details(this.$route.params.id);
    }
  }
};
</script>
<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-9">
            <div class="card rounded-5 border">
              <div class="card-body form-style">
                <div class="row mb-4">
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.reason}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="text-right custom-select-dd mb-lg-0 mb-3">
                      <select
                        v-model="order.reason"
                        class="form-control"
                        :class="{ 'is-danger': errors.has('source_store_id') }"
                        v-validate="'required'"
                        name="reason"
                      >
                        <option value>{{$lang.messages.reason}}</option>
                        <option value="RECEIVE_ITEMS">{{$lang.messages.received_item}}</option>
                        <option value="INVENTORY_COUNT">{{$lang.messages.inventory_count}}</option>
                        <option value="LOSS">{{$lang.messages.loss}}</option>
                        <option value="DAMAGE">{{$lang.messages.damage}}</option>
                      </select>

                      <i v-show="errors.has('reason')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('reason')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_reason}}</span>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <label for>{{$lang.messages.store}}</label>
                    <span style="color:#ff0000">*</span>
                    <div class="text-right custom-select-dd">
                      <select
                        v-model="filterObj.store_id"
                        class="form-control"
                        :class="{ 'is-danger': errors.has('store_id') }"
                        @change="getItemList()"
                        v-validate="'required'"
                        name="store_id"
                      >
                        <option value>{{$lang.messages.select_store}}</option>
                        <option v-for="obj in storeList" :key="obj.id" :value="obj.id">{{obj.name}}</option>
                      </select>

                      <i v-show="errors.has('store_id')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('store_id')"
                        class="help is-danger"
                      >{{$lang.messages.please_enter_select_store}}</span>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <label for>{{$lang.messages.notes}}</label>
                    <label class="float-right">{{note_count}} / 300</label>
                    <textarea
                      class="form-control"
                      rows="1"
                      :placeholder="$lang.messages.write_here_something"
                      style="height: auto"
                      v-model="order.note"
                      maxlength="300"
                      v-on:keyup="changeNoteCount()"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9">
            <div class="card rounded-5 border">
              <div class="card-header px-4 mt-1 py-3 bg-white border-bottom">
                <h3 class="font-22 d-inline-block">{{$lang.messages.items}}</h3>
                <div class="selectbox-xs custom-select-dd float-right" style="width: 275px"></div>
              </div>
              <div class="card-body form-style px-4">
                <div class="table-responsive">
                  <table class="table table-style-1">
                    <thead>
                      <tr>
                        <th scope="col" width="150">{{$lang.messages.item}}</th>
                        <th
                          scope="col"
                          width="120"
                          v-if="!order.reason || order.reason == 'RECEIVE_ITEMS' || order.reason == 'LOSS' || order.reason == 'DAMAGE'"
                        >{{$lang.messages.in_stock}}</th>
                        <th
                          scope="col"
                          v-if="!order.reason || order.reason == 'RECEIVE_ITEMS'"
                        >{{$lang.messages.add_stock}}</th>
                        <th
                          scope="col"
                          v-if="!order.reason || order.reason == 'RECEIVE_ITEMS'"
                        >{{$lang.messages.cost}}</th>
                        <th
                          scope="col"
                          width="90"
                          v-if="order.reason == 'INVENTORY_COUNT'"
                        >{{$lang.messages.expexted_stock}}</th>
                        <th
                          scope="col"
                          width="90"
                          v-if="order.reason == 'INVENTORY_COUNT'"
                        >{{$lang.messages.counted_stock}}</th>
                        <th
                          scope="col"
                          width="90"
                          v-if="order.reason == 'LOSS' || order.reason == 'DAMAGE'"
                        >{{$lang.messages.remove_stock}}</th>
                        <th
                          scope="col"
                          v-if="!order.reason || order.reason == 'RECEIVE_ITEMS' || order.reason == 'LOSS' || order.reason == 'DAMAGE'"
                        >{{$lang.messages.stock_after}}</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(sel, index)  in selected_items" :key="'composite_item_'+index">
                        <td class="align-middle">
                          <span class="f-semi-bold">{{sel.name}}</span>
                          <br />
                          <span v-if="sel.sku">{{$lang.messages.sku}} {{sel.sku}}</span>
                        </td>
                        <td
                          class="align-middle"
                          v-if="!order.reason || order.reason == 'RECEIVE_ITEMS' || order.reason == 'LOSS' ||
                          order.reason == 'DAMAGE' "
                        >{{sel.in_stock ? sel.in_stock: 0}}</td>
                        <td
                          class="align-middle"
                          v-if="!order.reason || order.reason == 'RECEIVE_ITEMS'"
                        >
                          <input
                            placeholder="0.00"
                            type="text"
                            v-model="sel.add_stock"
                            :id="'composite_item_add_stock_' + index"
                            :name="'composite_item_add_stock_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_add_stock_' + index) }"
                            v-validate="'required|decimal|min_value:1'"
                            @blur="calculateAmount(index)"
                          />
                          <i
                            v-show="errors.has('composite_item_add_stock_'+ index)"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('composite_item_add_stock_'+ index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_stock}}</span>
                        </td>
                        <td
                          class="align-middle"
                          v-if="!order.reason || order.reason == 'RECEIVE_ITEMS'"
                        >
                          <input
                            placeholder="0.00"
                            type="text"
                            v-model="sel.cost"
                            :id="'composite_item_cost_' + index"
                            :name="'composite_item_cost_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_cost_' + index) }"
                            v-validate="'required|decimal|min_value:1'"
                            @blur="calculateAmount(index)"
                          />
                          <i v-show="errors.has('composite_item_cost_'+ index)" class="fa fa-warning"></i>
                          <span
                            v-show="errors.has('composite_item_cost_'+ index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_cost}}</span>
                        </td>
                        <td
                          class="align-middle"
                          v-if="order.reason == 'INVENTORY_COUNT'"
                        >{{sel.in_stock}}</td>
                        <td class="align-middle" v-if="order.reason == 'INVENTORY_COUNT'">
                          <input
                            placeholder="0.00"
                            type="text"
                            v-model="sel.counted_stock"
                            :id="'composite_item_counted_stock_' + index"
                            :name="'composite_item_counted_stock_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_counted_stock_' + index) }"
                            v-validate="'required|decimal|min_value:1'"
                          />
                          <i
                            v-show="errors.has('composite_item_counted_stock_'+ index)"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('composite_item_counted_stock_'+ index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_counted_stock}}</span>
                        </td>
                        <td
                          class="align-middle"
                          v-if="order.reason == 'LOSS' || order.reason == 'DAMAGE'"
                        >
                          <input
                            placeholder="0.00"
                            type="text"
                            v-model="sel.remove_stock"
                            :id="'composite_item_remove_stock_' + index"
                            :name="'composite_item_remove_stock_' + index"
                            :class="{'form-control':true, 'input': true, 'is-danger': errors.has('composite_item_remove_stock_' + index) }"
                            v-validate="'required|decimal|min_value:1'"
                            @blur="calculateStock(index)"
                          />
                          <i
                            v-show="errors.has('composite_item_remove_stock_'+ index)"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('composite_item_remove_stock_'+ index)"
                            class="help is-danger"
                          >{{$lang.messages.please_enter_valid_remove_stock}}</span>
                        </td>
                        <td
                          class="align-middle"
                          v-if="!order.reason || order.reason == 'RECEIVE_ITEMS' || order.reason == 'LOSS' || order.reason == 'DAMAGE'"
                        >{{sel.stock_after}}</td>

                        <td class="align-middle">
                          <a href="javascript:void(0)" @click="removeSelectedItem(index)">
                            <i class="far fa-trash-alt font-20 text-danger"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <div>
                      <label class="typo__label">{{$lang.messages.item_search}}</label>
                      <span style="color:#ff0000">*</span>

                      <multiselect
                        v-validate="'required'"
                        v-model="selected_items"
                        :options="itemList"
                        :multiple="true"
                        :class="{'input': true, 'is-danger': errors.has('searchItem') }"
                        :close-on-select="true"
                        :clear-on-select="false"
                        v-bind:placeholder="$lang.messages.please_select_option"
                        label="name"
                        track-by="name"
                        name="searchItem"
                        :select-label="$lang.messages.please_enter_to_select"
                        :deselect-label="$lang.messages.please_enter_to_remove"
                        :selected-label="$lang.messages.selected"
                      >
                        <span slot="noOptions">{{$lang.messages.list_is_empty}}</span>
                        <template slot="selection">
                          <span class="multiselect__single" v-if="selected_items.length"></span>
                        </template>
                      </multiselect>

                      <i v-show="errors.has('searchItem')" class="fa fa-warning"></i>
                      <span
                        v-show="errors.has('searchItem')"
                        class="help is-danger"
                      >{{$lang.messages.please_select_atleast_one_item}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-9 text-lg-right text-center">
            <button
              type="button"
              class="btn btn-primary mr-3"
              id="save-btn"
              @click="validateForm()"
            >{{$lang.messages.adjust}}</button>
            <button
              type="submit"
              class="btn btn-outline-primary"
              id="cancel-btn"
              @click="$router.go(-1)"
            >{{$lang.messages.cancel_btn_text}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
